import React from "react";
import { Badge } from "@chakra-ui/react";

const BADGE_VARIANTS = {
  solid: { variant: "solid", colorScheme: "gwbi" },
  subtle: { variant: "subtle", colorScheme: "gwbi" },
  outline: { variant: "outline", colorScheme: "gwbi" },
};

export default function UiBadge({ variant = "subtle", ...props }) {
  const styleProps = BADGE_VARIANTS[variant] || BADGE_VARIANTS.subtle;
  return <Badge {...styleProps} {...props} />;
}
